module.exports = __webpack_public_path__ + "assets/img/coupon.2689583f.svg";